module.exports = __webpack_public_path__ + "img/crusher.ff0437f8.png";